import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';
import { useTrowser } from '@/modules/navigation/trowsers/trowser.context';
import { TrowserKey } from '@/modules/navigation/trowsers/trowser.types';
import { SmartReviewOnboardingModal } from '@/modules/onboarding/smartReview/SmartReviewOnboardingModal';
import { SmartReviewStep } from '@/modules/onboarding/smartReview/SmartReviewOnboardingModal.types';

import { ClientOverviewPageContentProps } from './ClientOverviewPageContent';

/** Stay mounted independently of document presence and setup progress. */
export function HouseholdOnboardingHost({
  householdId,
  household,
}: Pick<ClientOverviewPageContentProps, 'householdId' | 'household'>) {
  const canEdit = useCanEditHouseholdData();
  const trowser = useTrowser(TrowserKey.SmartReviewOnboarding);
  if (
    !canEdit ||
    !household ||
    !trowser.isOpen ||
    trowser.target !== householdId
  ) {
    return null;
  }

  return (
    <SmartReviewOnboardingModal
      isOpen
      onClose={trowser.close}
      initialHouseholdId={householdId}
      initialHouseholdClients={household.possiblePrimaryClients.map(
        (client) => ({
          firstName: client.firstName,
          lastName: client.lastName,
          stateCode: client.address?.stateCode ?? '',
        })
      )}
      initialStep={SmartReviewStep.DocumentUpload}
    />
  );
}
